/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Manageaccessdescription3Inputs */

const en_coinvestments_share_manageaccessdescription3 = /** @type {(inputs: Coinvestments_Share_Manageaccessdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage access to this opportunity`)
};

/**
* | output |
* | --- |
* | "Manage access to this opportunity" |
*
* @param {Coinvestments_Share_Manageaccessdescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_manageaccessdescription3 = /** @type {((inputs?: Coinvestments_Share_Manageaccessdescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Manageaccessdescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_manageaccessdescription3(inputs)
});
export { coinvestments_share_manageaccessdescription3 as "coInvestments_share_manageAccessDescription" }